import { filter, isEmpty } from "lodash-es";
import type { DynamicsType } from "~/server/types/dynamics";
import { LivEnum } from "~/types/user";

export const useSchema = () => {
  const dynamicsSchema = useState<Array<DynamicsType>>('dynamicsSchema', () => ([]));
  const dynamicFormSchema = useState<DynamicsType>('dynamicFormSchema', () => ({}));

  const {data: userData} = useAuth();

  const getMenuItems = async () => {
    if (isEmpty(dynamicsSchema.value)) {
      const appCookie = useCookie('app');
      const {data} = await useTenantFetch(`/api/dynamics?app=${appCookie.value}`);
      dynamicsSchema.value = data.value as DynamicsType[];
    }
    const tmpMenu =  [
      {
        table: '',
        name: 'Dashboard',
        relations: [],
        icon: 'chart-pie',
        inMenu: true,
        app: ['procedure']
      },
      ...filter(dynamicsSchema.value, (item: DynamicsType) => item.inMenu)
    ];
    if(userData.value?.user && [LivEnum.SUPERADMIN,LivEnum.ADMIN].includes(userData.value.user.liv)) {
      tmpMenu.push({
        table: 'impostazioni',
        name: 'Impostazioni',
        relations: [],
        icon: 'cog',
        inMenu: true,
        app: ['procedure']
      });
    
    }
    return tmpMenu;
  };

  const getSchema = (model: string) => {
    return;
  }
  return {
    dynamicsSchema,
    dynamicFormSchema,
    getMenuItems,
    getSchema,
  };
};